import { ethers } from 'ethers';
import { LEVER_SWAP_CONFIG } from './swapConfig';

export const ERC20_ABI = [
'function allowance(address owner, address spender) view returns (uint256)',
'function approve(address spender, uint256 amount) returns (bool)',
'function balanceOf(address) view returns (uint256)'];


export const STARTAX_SWAP_ABI = [
'function transactionMinimum() view returns (uint256)',
'function getTransactionMinimumInWETH() view returns (uint256)',
'function balanceOf(address) view returns (uint256)'];


export function isNativeAddress(address) {
  return String(address || '').toLowerCase() === LEVER_SWAP_CONFIG.NATIVE_ADDRESS.toLowerCase();
}

export function safeNormalize(address) {
  const value = String(address || '');
  if (isNativeAddress(value)) return LEVER_SWAP_CONFIG.NATIVE_ADDRESS;
  return ethers.getAddress(value.toLowerCase());
}

export function applyBuyFactor(baseAmountBN) {
  const factorText = String(LEVER_SWAP_CONFIG.BUY_FACTOR ?? '1');
  const [wholePart = '0', decimalPart = ''] = factorText.split('.');
  const scale = BigInt(10000);
  const whole = BigInt(wholePart || '0');
  const decimals = BigInt((decimalPart + '0000').slice(0, 4) || '0');
  const multiplier = whole * BigInt(scale) + BigInt(decimals);

  return BigInt(baseAmountBN) * BigInt(multiplier) / BigInt(scale);
}


export function normalizeSwapMultiplier(value) {
  const fallback = Number(LEVER_SWAP_CONFIG.DEFAULT_SWAP_MULTIPLIER || 1);
  const numeric = Number(value);
  const allowed = Array.isArray(LEVER_SWAP_CONFIG.SWAP_MULTIPLIERS) ?
  LEVER_SWAP_CONFIG.SWAP_MULTIPLIERS.map(Number) :
  [fallback];

  return allowed.includes(numeric) ? numeric : fallback;
}

export function applySwapMultiplier(baseAmountBN, multiplier = LEVER_SWAP_CONFIG.DEFAULT_SWAP_MULTIPLIER) {
  const safeMultiplier = normalizeSwapMultiplier(multiplier);
  return BigInt(baseAmountBN) * BigInt(safeMultiplier);
}

export function formatTokenFloor(amountBN, decimals = 18) {
  const formatted = ethers.formatUnits(amountBN || 0, decimals);
  return Math.floor(Number(formatted || 0));
}

export function bigNumberFromUnknown(value) {
  if (value == null) return null;
  try {return BigInt(String(value));} catch {return null;}
}
